export default __webpack_public_path__ + "static/media/headphone-alt.238bd900.svg";